import axios from "axios";

const API = process.env.REACT_APP_MICRO_SMART_URL;
const VERSION = process.env.REACT_APP_MICRO_SMART_URL_API;
const radio_id = localStorage.getItem("radio_id");

export const getPhoto = (params) => (dispatch) => {
  params.find_q = params.find_q?.slice(1).split("&")[0].split("=")[1];

  axios
    .get(
      `${API}${VERSION}/Photos/topics?page=${params.page}`,
      { params }
    )
    .then((response) => {
      dispatch({
        type: "GET_PHOTO",
        data: response.data.data.topicsList,
        allData: response.data.data.topicsList,
        recordsTotal: response.data.data.topicsList.total,
      });
    });
};